<h2 class="h2 mb-3">Soluzioni Disponibili</h2>
<div *ngIf="this.isLoadingDetail">

  <div class="d-flex">
    <span class="me-2">
      Caricamento delle soluzioni in corso
    </span>

    <div class="solution__loader is-loading">
      <div class="solution__loader__circle u-price-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>

</div>

<ng-container *ngIf="!this.isLoadingDetail">

  <ng-container *ngIf="!this.detailSolutions?.length">
    <!-- ...perchè non è stata selezionata una data-->
    <ng-container *ngIf="this.allAvailableDates?.length && !this.selectedDepartureDate">
      <span class="u-text--link" (click)="this.onClickOnChooseDate()">Seleziona una data</span> per
      visualizzare tutte le soluzioni disponibili.
    </ng-container>
    <!-- ...perchè non ci sono date disponibili o soluzioni per la data selezionata-->
    <ng-container *ngIf="!this.allAvailableDates?.length || this.selectedDepartureDate">
      Nessuna soluzione disponibile il {{this.selectedDepartureDate | date}}
      per {{this.formattedGuestsString}}.
    </ng-container>
  </ng-container>

  <ng-container *ngIf="this.detailSolutions?.length">

    <p class="mb3" *ngIf="this.detailSolutions.length === 1">È stata trovata <strong>1
      soluzione</strong> per il {{this.selectedDepartureDate | date}}.
    </p>

    <p class="mb3" *ngIf="this.detailSolutions.length > 1">Sono state trovate
      <strong>{{this.detailSolutions?.length}} soluzioni</strong>
      <ng-container *ngIf="this.selectedDepartureDate">
        per il <strong>{{this.selectedDepartureDate | date}}</strong>
      </ng-container>.
    </p>

    <div class="ofe-accordion">
      <div class="solution">
        <ngb-accordion #solutionsAccordion="ngbAccordion" activeIds="panel-0'">
          <ng-container *ngFor="let solution of this.detailSolutions; let index = index">
            <ngb-panel id="solution-{{solution.nights}}-{{solution?.airport || 'solo-soggiorno'}}">
              <ng-template ngbPanelHeader let-opened="opened">
                <div class="solution__header">
                  <div class="solution__toggle__wrapper">
                    <ng-container *ngIf="solution.flights && solution.airport > 1000000 && solution.airport < 2000000">
                      <button class="solution__toggle__button" ngbPanelToggle>
                        <i class="solution__toggle__icon icon-{{ opened ? 'minus' : 'plus'}}"></i>
                      </button>
                    </ng-container>
                  </div>
                  <p class="solution__title">
                    {{solution.nights}} {{solution.nights === 1 ? 'Notte' : 'Notti'}}
                    <span *ngIf="solution.flights">
                    da <strong>
                    {{ (solution.flights | aptDirection:'ANDATA')?.departureAirport?.name }}
                    </strong>
                  </span>
                    <span *ngIf="!solution.flights">
                      <span *ngIf="solution.airport > 2000000"> (Nave + Soggiorno) da </span>
                      <strong>
                        {{ (solution.airport | getDataFromMapping:'airportId' | async)?.Name || 'Solo Soggiorno' }}
                      </strong>
                    </span>
                  </p>

                  <span *ngIf="solution.isCheapest" class="solution__cheapest g-icon-medal"></span>

                  <!--  //  Loader-->
                  <div *ngIf="solution.isLoadingLiveInfo" class="solution__loader is-loading">
                    <div class="solution__loader__circle u-price-loader">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>

                  <!--  //  Prezzo-->
                  <span *ngIf="!solution.isLoadingLiveInfo && !solution.liveError && solution.totalPrice"
                        class="solution__price-diff">
                  <strong> da {{ solution.totalPrice | currency : 'EUR' }}</strong>
                </span>

                  <!-- // Seleziona-->
                  <div class="solution__select">
                    <button class="btn"
                            (click)="solution === selectedSolution ? null : onClickOnAlternativeSolution(solution)"
                            [ngClass]=" [
                            (solution === selectedSolution) ? 'btn--light-blue-outline' : 'btn--light-blue',
                            (solution?.isLoadingLiveInfo || solution?.liveError) ? 'disabled' : ''
                          ]">
                      {{solution === selectedSolution ? 'Selezionato' : 'Seleziona' }}
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-container *ngIf="solution.flights">
                <ng-template ngbPanelContent>
                  <holiday-detail-generic-page-solution-card [solution]="solution">
                  </holiday-detail-generic-page-solution-card>
                </ng-template>
              </ng-container>
            </ngb-panel>
          </ng-container>
        </ngb-accordion>
      </div>
    </div>

  </ng-container>

</ng-container>



